var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowerGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Shower_-_Grey"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M94.621,107.946V34.951 c0-6.262-5.076-11.339-11.339-11.339H64.96c-6.262,0-11.339,5.076-11.339,11.339v3.995L37.699,56.13 c-1.681,1.815-0.394,4.761,2.079,4.761h27.085c2.41,0,3.721-2.816,2.169-4.66L53.621,38.946"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 41.621,
    y1: 66.613,
    x2: 41.621,
    y2: 70.613
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "7.8525,7.8525"
    },
    x1: 41.621,
    y1: 78.465,
    x2: 41.621,
    y2: 90.244
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 41.621,
    y1: 94.17,
    x2: 41.621,
    y2: 98.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 49.621,
    y1: 66.613,
    x2: 49.621,
    y2: 70.613
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "7.8525,7.8525"
    },
    x1: 49.621,
    y1: 78.465,
    x2: 49.621,
    y2: 90.244
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 49.621,
    y1: 94.17,
    x2: 49.621,
    y2: 98.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 57.121,
    y1: 66.613,
    x2: 57.121,
    y2: 70.613
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "7.8525,7.8525"
    },
    x1: 57.121,
    y1: 78.465,
    x2: 57.121,
    y2: 90.244
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 57.121,
    y1: 94.17,
    x2: 57.121,
    y2: 98.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 64.871,
    y1: 66.613,
    x2: 64.871,
    y2: 70.613
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "7.8525,7.8525"
    },
    x1: 64.871,
    y1: 78.465,
    x2: 64.871,
    y2: 90.244
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 64.871,
    y1: 94.17,
    x2: 64.871,
    y2: 98.17
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#D7D7D7",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerGrey);
export default __webpack_public_path__ + "static/media/Shower - Grey.d42382bdc2808db43b122020c7fef579.svg";
export { ForwardRef as ReactComponent };